import { odV3En, odV3Pl } from './owner-dashboard-v3';

/** Pulpit menedżera (zarząd i administrator) + Ustawienia → Pulpit menedżera. */
export const odPl = {
  v3: odV3Pl,
  nav: 'Pulpit menedżera',
  description: 'Najważniejsze wskaźniki firmy w jednym miejscu',
  title: 'Pulpit menedżera',
  subtitle: '{date} · dane z miesiąca bieżącego · import ERP: {erp}',
  noErp: 'brak danych',
  refresh: 'Odśwież',
  period: { today: 'Dziś', week: 'Tydzień', month: 'Miesiąc', quarter: 'Kwartał', monthNote: 'Widok pokazuje miesiąc bieżący (od początku miesiąca do dziś).' },
  chips: { critical: '{count} alertów krytycznych', approvals: '{count} do akceptacji', allClear: 'Brak pilnych spraw' },
  unavailable: 'Część danych jest chwilowo niedostępna: {sections}.',
  sectionUnavailable: 'Dane tej sekcji są chwilowo niedostępne.',
  ai: { title: 'Co się zmieniło i dlaczego', all: 'Zarząd →' },
  kpi: {
    sales: 'Sprzedaż netto (miesiąc)',
    vsPrev: '{delta} vs poprz. okres',
    realization: 'Realizacja celu',
    toTarget: 'Do celu: {value}',
    noTarget: 'Brak celu',
    forecast: 'Prognoza końca miesiąca',
    forecastNote: '{pct} celu · szansa {prob}',
    margin: 'Marża',
    marginNote: '{delta} vs poprz. okres',
    overdue: 'Należności po terminie',
    overdueNote: '{pct} portfela · {count} klientów',
    customers: 'Aktywni klienci',
    customersNote: '+{added} nowych · −{lost} utraconych',
    thresholdBad: 'poniżej progu',
  },
  chart: { title: 'Sprzedaż narastająco vs cel', actual: 'Sprzedaż', target: 'Cel', forecast: 'Prognoza', today: 'dziś', more: 'Zarząd →' },
  map: { title: 'Handlowcy w terenie — na żywo', more: 'Mapa na żywo →', inVisit: 'w wizycie', moving: 'w ruchu', stopped: 'postój', idle: 'bez ruchu', off: 'poza pracą', empty: 'Brak pozycji handlowców.', visits: 'wizyty {done}/{total}' },
  decisions: {
    title: 'Wymaga decyzji',
    alerts: 'Alerty krytyczne',
    approvals: 'Akceptacje klientów',
    approvalsOverdue: 'po terminie: {count}',
    tasks: 'Zaległe zadania zespołu',
    leads: 'Leady bez ruchu 14+ dni',
    debtors: 'Klienci z długiem po terminie',
    allClear: 'Nic nie wymaga Twojej decyzji.',
  },
  leads: { title: 'Lejek leadów', more: 'Leady →', winRate: 'Skuteczność (12 mies.): {pct}', empty: 'Brak otwartych leadów.' },
  team: { title: 'Zespół — realizacja celu', more: 'Zespół →', empty: 'Brak danych o zespole.' },
  field: {
    title: 'Teren dziś',
    more: 'Wizyty →',
    visits: 'Wizyty wykonane / plan',
    overdue: 'Wizyty zaległe',
    avg: 'Średni czas wizyty',
    avgMin: '{n} min',
    leads: 'Nowe leady z terenu',
    inField: 'Handlowcy w terenie',
  },
  logistics: { title: 'Logistyka dziś', more: 'Logistyka →', planned: 'Dostawy zaplanowane / zrealizowane', late: 'Opóźnione', failed: 'Nieudane' },
  risk: { title: 'Ryzyko klientów', more: 'Klienci →', top10: 'Koncentracja: top 10 klientów', empty: 'Brak klientów ze spadkiem.' },
  receivables: { title: 'Należności — wiekowanie', more: 'Należności →' },
  marginGroups: { title: 'Marża wg grup', more: 'Marża →', best: 'Najlepsze', worst: 'Najsłabsze' },
  system: {
    title: 'Stan systemu i koszty',
    more: 'Administracja →',
    erp: 'Import ERP',
    version: 'Wersja',
    users: 'Aktywni dziś',
    ai: 'Koszt AI (mies.)',
  },
  settings: {
    nav: 'Pulpit menedżera',
    title: 'Ustawienia',
    description: 'Ustawienia organizacji',
    section: 'Pulpit menedżera',
    sectionHint: 'Poranny raport e-mail i progi kolorów wskaźników.',
    readOnly: 'Ustawienia może zmieniać tylko administrator.',
    save: 'Zapisz ustawienia',
    saved: 'Ustawienia zapisane.',
    saveFailed: 'Nie udało się zapisać ustawień.',
    report: {
      title: 'Poranny raport e-mail',
      enabled: 'Wysyłaj raport',
      recipients: 'Odbiorcy',
      recipientsHint: 'Wpisz adres i naciśnij Enter.',
      addPlaceholder: 'adres@firma.pl',
      add: 'Dodaj adres',
      remove: 'Usuń: {address}',
      invalid: 'Niepoprawny adres e-mail.',
      noRecipients: 'Brak odbiorców — raport nie zostanie wysłany.',
      time: 'Godzina wysyłki',
      days: 'Dni tygodnia',
      content: 'W raporcie: kafelki wskaźników, „Co się zmieniło i dlaczego” oraz lista spraw wymagających decyzji.',
      test: 'Wyślij próbny na mój adres',
      testSent: 'Wysłano próbny raport na {address}.',
      testFailed: 'Nie udało się wysłać próbnego raportu (sprawdź ustawienia poczty serwera).',
      lastSent: 'Ostatnia wysyłka: {date}',
      never: 'jeszcze nie wysłano',
    },
    thresholds: {
      title: 'Progi kolorów',
      indicator: 'Wskaźnik',
      warn: 'Żółty',
      bad: 'Czerwony',
      realization: 'Realizacja celu (poniżej, %)',
      overdue: 'Należności po terminie (powyżej, % portfela)',
      margin: 'Spadek marży (powyżej, pp)',
      visits: 'Wizyty zaległe (powyżej, % planu)',
      idle: 'Handlowiec bez ruchu (minuty)',
      reset: 'Przywróć domyślne',
      error: 'Czerwony próg nie może być łagodniejszy niż żółty.',
    },
    weekdays: { 1: 'pn', 2: 'wt', 3: 'śr', 4: 'cz', 5: 'pt', 6: 'sob', 7: 'nd' },
  },
};

export const odEn: typeof odPl = {
  v3: odV3En,
  nav: 'Manager dashboard',
  description: 'The most important company indicators in one place',
  title: 'Manager dashboard',
  subtitle: '{date} · current month · ERP import: {erp}',
  noErp: 'no data',
  refresh: 'Refresh',
  period: { today: 'Today', week: 'Week', month: 'Month', quarter: 'Quarter', monthNote: 'The view shows the current month (from the start of the month to today).' },
  chips: { critical: '{count} critical alerts', approvals: '{count} awaiting approval', allClear: 'Nothing urgent' },
  unavailable: 'Some data is temporarily unavailable: {sections}.',
  sectionUnavailable: 'This section is temporarily unavailable.',
  ai: { title: 'What changed and why', all: 'Board →' },
  kpi: {
    sales: 'Net sales (month)',
    vsPrev: '{delta} vs previous period',
    realization: 'Target attainment',
    toTarget: 'To target: {value}',
    noTarget: 'No target',
    forecast: 'End-of-month forecast',
    forecastNote: '{pct} of target · chance {prob}',
    margin: 'Margin',
    marginNote: '{delta} vs previous period',
    overdue: 'Overdue receivables',
    overdueNote: '{pct} of the portfolio · {count} customers',
    customers: 'Active customers',
    customersNote: '+{added} new · −{lost} lost',
    thresholdBad: 'below the threshold',
  },
  chart: { title: 'Cumulative sales vs target', actual: 'Sales', target: 'Target', forecast: 'Forecast', today: 'today', more: 'Board →' },
  map: { title: 'Reps in the field — live', more: 'Live map →', inVisit: 'in a visit', moving: 'moving', stopped: 'stopped', idle: 'idle', off: 'off duty', empty: 'No rep positions.', visits: 'visits {done}/{total}' },
  decisions: {
    title: 'Needs a decision',
    alerts: 'Critical alerts',
    approvals: 'Customer approvals',
    approvalsOverdue: 'overdue: {count}',
    tasks: 'Overdue team tasks',
    leads: 'Leads idle 14+ days',
    debtors: 'Customers with overdue debt',
    allClear: 'Nothing needs your decision.',
  },
  leads: { title: 'Lead funnel', more: 'Leads →', winRate: 'Win rate (12 mo.): {pct}', empty: 'No open leads.' },
  team: { title: 'Team — target attainment', more: 'Team →', empty: 'No team data.' },
  field: {
    title: 'Field today',
    more: 'Visits →',
    visits: 'Visits done / planned',
    overdue: 'Overdue visits',
    avg: 'Average visit time',
    avgMin: '{n} min',
    leads: 'New leads from the field',
    inField: 'Reps in the field',
  },
  logistics: { title: 'Logistics today', more: 'Logistics →', planned: 'Deliveries planned / done', late: 'Late', failed: 'Failed' },
  risk: { title: 'Customer risk', more: 'Customers →', top10: 'Concentration: top 10 customers', empty: 'No declining customers.' },
  receivables: { title: 'Receivables — aging', more: 'Receivables →' },
  marginGroups: { title: 'Margin by group', more: 'Margin →', best: 'Best', worst: 'Weakest' },
  system: {
    title: 'System status and costs',
    more: 'Administration →',
    erp: 'ERP import',
    version: 'Version',
    users: 'Active today',
    ai: 'AI cost (month)',
  },
  settings: {
    nav: 'Manager dashboard',
    title: 'Settings',
    description: 'Organization settings',
    section: 'Manager dashboard',
    sectionHint: 'Morning e-mail report and indicator color thresholds.',
    readOnly: 'Only an administrator can change these settings.',
    save: 'Save settings',
    saved: 'Settings saved.',
    saveFailed: 'Could not save the settings.',
    report: {
      title: 'Morning e-mail report',
      enabled: 'Send the report',
      recipients: 'Recipients',
      recipientsHint: 'Type an address and press Enter.',
      addPlaceholder: 'name@company.com',
      add: 'Add address',
      remove: 'Remove: {address}',
      invalid: 'Invalid e-mail address.',
      noRecipients: 'No recipients — the report will not be sent.',
      time: 'Send time',
      days: 'Days of the week',
      content: 'The report contains: indicator tiles, “What changed and why” and the list of items needing a decision.',
      test: 'Send a test to my address',
      testSent: 'A test report was sent to {address}.',
      testFailed: 'Could not send the test report (check the server mail settings).',
      lastSent: 'Last sent: {date}',
      never: 'not sent yet',
    },
    thresholds: {
      title: 'Color thresholds',
      indicator: 'Indicator',
      warn: 'Yellow',
      bad: 'Red',
      realization: 'Target attainment (below, %)',
      overdue: 'Overdue receivables (above, % of portfolio)',
      margin: 'Margin drop (above, pp)',
      visits: 'Overdue visits (above, % of plan)',
      idle: 'Rep idle (minutes)',
      reset: 'Restore defaults',
      error: 'The red threshold cannot be milder than the yellow one.',
    },
    weekdays: { 1: 'Mon', 2: 'Tue', 3: 'Wed', 4: 'Thu', 5: 'Fri', 6: 'Sat', 7: 'Sun' },
  },
};
